
import { Vue, Options } from 'vue-class-component'
import { Chart } from 'chart.js'

@Options({
  props: {
    payment_statistic: Object
  },
  name: 'BarChart',
  watch: {
    payment_statistic: {
      handler: 'loadDatas',
      deep: true
    }
  },
  data () {
    return {
      barchart: null,
      barChartConfig: {
        type: 'bar',
        responsive: true,
        data: {
          labels: [
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun'
          ],
          datasets: [
            {
              label: 'Belum Bayar',
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
              backgroundColor: '#379AE6'
            },
            {
              label: 'Terbayar',
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
              backgroundColor: '#C3E1F8'
            }
          ]
        },
        options: {
          responsive: true,
          lineTension: 1,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  padding: 25
                }
              }
            ]
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                return (
                  data.datasets[tooltipItem.datasetIndex].label +
                  ': ' +
                  data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString()
                )
              }
            }
          }
        }
      }
    }
  },
  methods: {
    loadDatas: async function () {
      const data = this.payment_statistic

      this.barChartConfig.data.datasets[0].data = data.unpaid
      this.barChartConfig.data.datasets[1].data = data.paid
      const ctx = document.getElementById('barchart') as HTMLCanvasElement

      // check if chart already initialized
      if (this.barchart !== null) {
        this.barchart.update()
      } else {
        this.barchart = new Chart(ctx, this.barChartConfig)
      }
    }
  },
  mounted () {
    this.loadDatas()
  }
})
export default class BarChart extends Vue { }
